import { render, staticRenderFns } from "./freightProp.vue?vue&type=template&id=7b0afef2&scoped=true&"
import script from "./freightProp.vue?vue&type=script&lang=js&"
export * from "./freightProp.vue?vue&type=script&lang=js&"
import style0 from "./freightProp.vue?vue&type=style&index=0&id=7b0afef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0afef2",
  null
  
)

export default component.exports